module.exports = __webpack_public_path__ + "assets/img/14.ff70edf8.png";